var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-center"},[(_vm.photoReady)?_c('v-btn',{attrs:{"color":"success","disabled":_vm.uploading,"loading":_vm.uploading},on:{"click":_vm.saveAndContinue}},[_vm._v("Continuer")]):_vm._e()],1),_c('photo-shooter',{ref:"shooter",on:{"photoReady":function($event){_vm.photoReady = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }